module.exports = __webpack_public_path__ + "static/media/retos_grupos.6350ae7e.png";